import { Card, Panel, ConfirmModal } from '@/components/Bicester';
import Image from '@/components/Bicester/Image';
import { Form } from '@/components/formik-rsuite';
import { LEVEL_TYPE } from '@/constants';
import { fetchServiceMemberInfo } from '@/services/site';
import { getPathname, push } from '@/utils/history';
import { ACCOUNT_TABS } from '@/views/CustomerAccount';
import { useRequest } from 'ahooks';
import { FormikProvider, useFormik } from 'formik';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { Alert, IconButton } from 'rsuite';
import { Member } from '..';
import { useModal } from '@ebay/nice-modal-react';
import useRouter from '@/hooks/useRouter';
import { useLocation } from 'react-router-dom';

interface MatchInfo {
  phone: string; // 手机号
  user_code: string; // 会员号
}

const MatchMember = ({
  member,
  setMember,
  height,
  onlyMatchMember = false,
}: {
  member: Member;
  setMember: (member: Member) => void;
  height?: number | string;
  /**
   * 只匹配会员，非会员则报错
   */
  onlyMatchMember?: boolean;
}) => {
  const { pathname } = useLocation();
  const modal = useModal(ConfirmModal);
  const { query } = useRouter();

  const {
    run: getServiceMemberInfo,
    data: serviceMemberInfoData,
    loading: serviceMemberInfoLoading,
  } = useRequest(fetchServiceMemberInfo, {
    manual: true,
  });

  const defaultInfo: MatchInfo = {
    phone: '',
    user_code: '',
  };

  const formik = useFormik({
    initialValues: defaultInfo,
    onSubmit(values, actions) {
      getServiceMemberInfo(values)
        .then((res) => {
          if (onlyMatchMember) {
            if (res?.data?.id) {
              if (res?.data?.level !== LEVEL_TYPE.NOT) {
                Alert.success('匹配成功');
                setMember(res.data);
              } else {
                Alert.error('会员不存在');
              }
            } else if (values.phone || values.user_code) {
              Alert.error('会员不存在');
            }
          } else {
            if (res?.data?.id) {
              Alert.success('匹配成功');
              setMember(res.data);
            } else if (values.phone || values.user_code) {
              modal.show({
                contentText: '无法匹配会员，是否创建非会员账户？',
                submitText: '开始创建',
                cancelText: '暂不',
                onSubmit() {
                  push(
                    `/customer-account/no-member/create${
                      values?.phone ? `?phone=${values.phone}` : ''
                    }`
                  );
                },
              });
            }
          }
        })
        .catch((e) => {
          actions.setErrors(e.formError);
        });
    },
  });

  useEffect(() => {
    if (query?.nomemberid || query?.memberid) {
      const { memberid, nomemberid } = query;
      getServiceMemberInfo({
        ...(memberid && { member_id: memberid }),
        ...(nomemberid && { not_member_id: nomemberid }),
      }).then((res) => {
        if (res?.data?.id) {
          setMember(res.data);
        } else {
          modal.show({
            contentText: '无法匹配会员，是否创建非会员账户？',
            submitText: '开始创建',
            cancelText: '暂不',
            onSubmit() {
              push('/customer-account/no-member/create');
            },
          });
        }
      });
    }
  }, []);

  useEffect(() => {
    if (!member) {
      formik.resetForm();
    }
  }, [pathname, member]);

  return (
    <FormikProvider value={formik}>
      <Form>
        <Panel title="匹配客户" loading={serviceMemberInfoLoading} style={{ height }} leftShadow>
          <div className="flex">
            <Card horizontal smDivider style={{ width: '50%' }}>
              <Card.Input label="手机号" formKey="phone" />
              <Card.Input label="会员号" formKey="user_code" />
            </Card>
            <Card horizontal smDivider style={{ width: '50%' }}>
              <div className="w-[30px] h-[47px] ml-[10px] flex items-center">
                <IconButton type="submit" style={{ width: 30, backgroundColor: 'transparent' }}>
                  <Image src="/resources/images/match.svg" />
                </IconButton>
              </div>
              {member?.id && (
                <>
                  <Card.Input
                    notEditable
                    className="flex-[2]"
                    label="客户名"
                    formKey="name"
                    value={member?.name}
                    autoWidth
                    hasBtn
                    customBtn={
                      <IconButton
                        style={{ width: 20, backgroundColor: 'transparent' }}
                        onClick={() => {
                          window.open(
                            getPathname(
                              `/customer-account/${
                                member?.level === LEVEL_TYPE.NOT
                                  ? ACCOUNT_TABS.NO_MEMBER
                                  : ACCOUNT_TABS.MEMBER
                              }/detail/${member?.id}`
                            )
                          );
                        }}
                      >
                        <Image
                          src={`/resources/images/user${
                            member?.sex === '男' ? '-man' : member?.sex === '女' ? '-woman' : ''
                          }.svg`}
                        />
                      </IconButton>
                    }
                  />
                  <Card.Input
                    className="flex-[2]"
                    notEditable
                    label="会员等级"
                    formKey="level"
                    inputType="level"
                    value={member.level}
                  />
                  <Card.Picker
                    notEditable
                    label="性别"
                    formKey="sex"
                    pickerType="sex"
                    value={member.sex}
                  />
                </>
              )}
            </Card>
          </div>
        </Panel>
      </Form>
    </FormikProvider>
  );
};

export default MatchMember;
